module.exports = __webpack_public_path__ + "img/logo PWr biale ang poziom  bez tla.06754a48.png";